import Transform from '@ember-data/serializer/transform';
import fixVideoUrl from 'garaje/utils/fix-video-url';

/**
 * This is mostly a copy of ember-data's default StringTransform except that it
 * runs the value through the `fixVideoUrl` util when serializing.
 */
export default class VideoUrlTransform extends Transform {
  serialize(deserialized: unknown): string | null {
    if (!deserialized && deserialized !== '') return null;
    const str = String(deserialized); // eslint-disable-line @typescript-eslint/no-base-to-string
    return fixVideoUrl(str);
  }

  deserialize(serialized: unknown): string | null {
    return !serialized && serialized !== '' ? null : String(serialized); // eslint-disable-line @typescript-eslint/no-base-to-string
  }
}
